import React from 'react';
import clsx from 'clsx';
import { StatsCard } from 'common/components';
import { useStyles } from 'features/command-center/components/shared';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS, TABLES_KEYS } from 'features/command-center/constants';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import DataTable from 'UI/components/organisms/DataTable';

import { formatProductionRosterResponse } from '../../productionBoard.utils';

import { ORDER_BY_OPTIONS, PRODUCTION_ROSTER_COLUMNS } from './productionRoster.columns';

const TABLE_KEY = TABLES_KEYS.productionBoardRoster;
const initialPreferences = getColumnPreferences(
  TABLE_KEY,
  0,
  ORDER_BY_OPTIONS,
  PRODUCTION_ROSTER_COLUMNS
);

export const ProductionRoster = ({ queryParams }) => {
  const classes = useStyles();
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productivityTeamHeadCount}?${queryParams}`;

  const { columnPreferences, data, listState, handleColumnSortChange } = useDatatable({
    key: TABLE_KEY,
    apiInstance: SECONDARY_API_CLIENT,
    columnsDefinitions: PRODUCTION_ROSTER_COLUMNS,
    endpoint,
    formatResponse: formatProductionRosterResponse,
    initialPreferences,
    orderByOptions: ORDER_BY_OPTIONS
  });

  const { isLoading, showWholeSkeleton } = listState;
  const { columns } = columnPreferences;
  const isEmpty = Array.isArray(data) && data.length === 0;

  return (
    <div>
      <StatsCard header={strings.commandCenter.productionBoard.byRoster} paddingContent={0}>
        <DataTable
          className={clsx({
            [classes.firstRow]: !isEmpty
          })}
          columns={getColumnsToRender(columns)}
          components={{ TableToolbar: () => null }}
          data={data}
          elevation={0}
          expandableRowsHeader={false}
          filter={false}
          isRowExpandable={() => true}
          loading={showWholeSkeleton}
          onColumnSortChange={handleColumnSortChange}
          refreshing={isLoading}
          rowsExpanded={[]}
          search={false}
          selectableRows="none"
          viewColumns={false}
        />
      </StatsCard>
    </div>
  );
};
